import TYPES from '../../types';

// Domain
import { CustomerAddressEntity } from '../../domain/entities/customer-address-entity';
import { SearchAddressRepository } from '../../domain/repository/search-address-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchAddressQuery extends Query<Promise<Array<CustomerAddressEntity>>> {
  @Inject(TYPES.MY_INVESTMENT_ADDRESS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.MY_INVESTMENT_ADDRESS_REPOSITORY)
  private readonly repository!: SearchAddressRepository;

  internalExecute(): Promise<Array<CustomerAddressEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
